import { render, staticRenderFns } from "./ComposizioneTrenoPartenza.vue?vue&type=template&id=47e467e9&scoped=true&"
import script from "./ComposizioneTrenoPartenza.vue?vue&type=script&lang=js&"
export * from "./ComposizioneTrenoPartenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e467e9",
  null
  
)

export default component.exports